(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-title-fit"] && !Shopify.designMode) return;
  try {
    (function () {
    function initTextFitToWidth(root) {
      const scope = root || document;
      const elements = [...scope.querySelectorAll("[data-fit-width]")];
      if (!elements.length) return () => {};
      const groups = new Map();
      elements.forEach((el) => {
        const parent = el.parentElement;
        if (!parent) return;
        el.style.whiteSpace = "nowrap";
        if (!groups.has(parent)) groups.set(parent, []);
        groups.get(parent).push(el);
      });
      function availableWidth(parent) {
        const cs = getComputedStyle(parent);
        return parent.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      }
      function fit(el, available) {
        if (available <= 0) return;
        let size = parseFloat(getComputedStyle(el).fontSize) || 16;
        for (let i = 0; i < 5; i++) {
          const width = el.getBoundingClientRect().width;
          if (width <= 0) break;
          const ratio = available / width;
          if (Math.abs(ratio - 1) < 0.002) break;
          size *= ratio;
          el.style.fontSize = size + "px";
        }
      }
      function refit() {
        groups.forEach((els, parent) => {
          const available = availableWidth(parent);
          els.forEach((el) => fit(el, available));
        });
      }
      let frame = null;
      function schedule() {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = null;
          refit();
        });
      }
      let ro;
      if (window.ResizeObserver) {
        ro = new ResizeObserver(schedule);
        groups.forEach((els, parent) => ro.observe(parent));
      }
      window.addEventListener("resize", schedule);
      refit();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
      return () => {
        if (frame) cancelAnimationFrame(frame);
        if (ro) ro.disconnect();
        window.removeEventListener("resize", schedule);
        elements.forEach((el) => {
          el.style.whiteSpace = "";
          el.style.fontSize = "";
        });
      };
    }

    if (customElements.get("fit-text-width")) return;

    class FitTextWidth extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia("(min-width: 750px)");
        this.onMediaChange = () => this.sync();
        this.mediaQuery.addEventListener("change", this.onMediaChange);
        this.sync();
      }

      disconnectedCallback() {
        if (this.mediaQuery) this.mediaQuery.removeEventListener("change", this.onMediaChange);
        this.destroy();
      }

      sync() {
        if (this.mediaQuery.matches) {
          if (!this.teardown) this.teardown = initTextFitToWidth(this);
        } else {
          this.destroy();
        }
      }

      destroy() {
        if (this.teardown) {
          this.teardown();
          this.teardown = null;
        }
      }
    }

    customElements.define("fit-text-width", FitTextWidth);
  })();
  } catch(e) { console.error(e); }
})();

})();
